import type {AiPromptBoxFooterLeftActionsProps} from '@Components/ai-prompt-box/components/ai-prompt-box-footer-left-actions/ai-prompt-box-footer-left-actions.types';
import type {ReactElement} from 'react';
import React from 'react';

export function AiPromptBoxFooterLeftActions(props: AiPromptBoxFooterLeftActionsProps): ReactElement | null {

  const getActions = (): ReactElement[] | null => {
    const footerLeftActions = props.options ?? [];

    if (footerLeftActions.length === 0) {
      return null;
    }

    return footerLeftActions.map((ActionComponent, index) => (
      <React.Fragment key={index}>
        <ActionComponent promptBoxId={props.id} footerRef={props.footerRef} />
      </React.Fragment>
    ));
  };

  const getFooter = (): ReactElement => {
    return (
      <div data-prompt-box-id={props.id}>
        <div className="flexbox gap-1 flex-align-items-center">{getActions()}</div>
      </div>
    );
  };

  return getFooter();
}
